module.exports = __webpack_public_path__ + "img/2.6fa97a49.png";